export default __webpack_public_path__ + "static/media/male-tourist-backpack-waving-his-hand-isolated-white-background-35845466.6b03eda7.jpg";